var _polygon, _path, _polygon2, _circle;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMarker(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 16 16",
    width: "16px",
    height: "16px",
    baseProfile: "basic",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    fill: "#36c8f6",
    points: "4,2 16,2 16,7 14,8 14,9 16,10 16,12 15,13 15,15 12,16 11,16 9,14 8,14 7,15 3,15 1,13 1,10 0,8 0,6"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fe3155",
    d: "M7,0C4.791,0,3,1.791,3,4s1.791,4,4,4s4-1.791,4-4S9.209,0,7,0z"
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    fill: "#fe3155",
    points: "3.962,6.591 7,9.846 10.038,6.591"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 7,
    cy: 4,
    r: 1.5,
    fill: "#fedb29"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMarker);
export default __webpack_public_path__ + "static/media/marker.f604f62d4ad19ade4e59029dd5e33761.svg";
export { ForwardRef as ReactComponent };